/* Cart room-plan reminder. The builder owns its state; the cart only checks
   whether a structurally valid browser-local plan exists and routes back to it. */
(function () {
  'use strict';
  function hasPlan() {
    try {
      var raw = localStorage.getItem('ctxGymStudio.last') || '';
      var head = raw.split('~')[0].split('_');
      return raw.indexOf('~') > -1 && parseInt(head[0], 10) > 0 && parseInt(head[1], 10) > 0 && raw.split('~')[1];
    } catch (e) { return false; }
  }
  function render() {
    if (!hasPlan()) return;
    document.querySelectorAll('[data-ctx-cart-plan-review]').forEach(function (box) {
      box.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
